<template>
    <div class="@container/media-preview relative">
        <template v-if="!error">
            <img v-if="isImage"
                class="w-full h-auto max-h-[50vh] object-cover rounded-md"
                :src="props.mediaUrl"
                :alt="`message_image`"
                @error="error = true" />
            <video v-else-if="isVideo"
                controls
                class="w-full max-h-[50vh] mx-auto aspect-video rounded-md">
                <source :src="props.mediaUrl"
                    :type="props.mediaContentType"
                    @error="error = true" />
            </video>
            <audio v-else-if="isAudio"
                controls
                class="w-full max-h-[50vh] mx-auto aspect-video">
                <source :src="props.mediaUrl"
                    :type="props.mediaContentType"
                    @error="error = true" />
            </audio>
            <a v-else
                :href="props.mediaUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="border-dashed border-slate-300 rounded-md flex justify-center items-center mx-auto w-full max-w-[160px] h-28 no-underline!">
                <font-awesome-icon widthAuto :icon="isPdf ? faFilePdf : (isVCard ? faAddressCard : faFile)"
                    class="text-sky-400 text-3xl @sm/media-preview:text-5xl" />
            </a>
        </template>
        <div v-if="error"
            class="flex flex-col items-center justify-center gap-1 border-dashed border-slate-300 rounded-md mx-auto w-full max-w-[160px] h-28">
            <font-awesome-icon widthAuto :icon="faFileXmark"
                class="text-slate-500 text-3xl @sm/media-preview:text-5xl" />
            <div class="text-balance text-center text-xs text-slate-600">
                Unable to open the file.
            </div>
        </div>

        <vx-button v-if="props.removeable"
            @click.prevent="emit('remove')"
            type="button"
            size="sm"
            color="white"
            shadow
            :class="{
                'absolute! inset-e-2 inset-bs-2': !isAudio,
                'mx-auto my-2 block!': isAudio,
            }"
            aria-label="Remove">
            <span class="hidden @xs/media-preview:inline">Remove</span>
            <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
        </vx-button>
    </div>
</template>

<script setup>
import { VxButton } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faAddressCard, faFile, faFilePdf, faFileXmark, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { computed, ref } from 'vue';

const props = defineProps({
    mediaUrl: {
        type: String,
        required: true
    },
    mediaContentType: {
        type: String,
        required: false,
    },
    removeable: Boolean,
});

const emit = defineEmits(['remove']);

const isImage = computed(() => Boolean(props.mediaUrl?.toLowerCase()?.match(/\.(png|jpg|jpeg|gif|bmp)$/)));
const isVideo = computed(() => Boolean(props.mediaUrl?.toLowerCase().match(/\.(mp4|webm)$/)));
const isAudio = computed(() => Boolean(props.mediaUrl?.toLowerCase().match(/\.(mp3|mpeg|ogg|wav)$/)));
const isPdf = computed(() => Boolean(props.mediaUrl?.toLowerCase().match(/\.(pdf)$/)));
const isVCard = computed(() => Boolean(props.mediaUrl?.toLowerCase().match(/\.(vcf|vcard)$/)));

const error = ref(false);
</script>
